import React from 'react';
export function MechanismSection() {
  return <section id="how-it-works" className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_bottom_left,rgba(0,102,255,0.15)_0%,transparent_60%),linear-gradient(180deg,var(--dark-bg),var(--card-bg))]" data-id="element-85" data-mp="322cfzoyq453j">
      <div className="max-w-[900px] mx-auto" data-id="element-86" data-mp="cfgdgdiahd7p">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-87" data-mp="8d3atxyu9vf5">
          The mechanism
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-88" data-mp="103hkfhztkll0">
          How the
          <br data-id="element-89" data-mp="vbppkv9mrtp2" />
          <span className="text-gradient-blue" data-id="element-90" data-mp="vb6jcbtcetqv">P-G-E Cycle</span> works —<br data-id="element-91" data-mp="rb5rnph8gm1v" />
          and how you break it
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-0 my-4 flex-wrap" data-id="element-92" data-mp="ranr4gnjflo5">
          {/* Node 1: Pleasure */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(255,165,0,0.2)] to-[rgba(255,215,0,0.1)] border-2 border-[rgba(255,165,0,0.5)]" data-id="element-93" data-mp="1j2bx8lfq3byj">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-94" data-mp="cplgrlvsova4">✨</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-gold" data-id="element-95" data-mp="cr4xfdld58cf">
              PLEASURE
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-96" data-mp="2z8y5z7jjc6m">
              The brain tries to relieve the emptiness with an immediate reward
            </div>
          </div>
          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-97" data-mp="3l7853jch6x0r">
            →
          </div>
          {/* Node 2: Guilt */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(194,0,111,0.2)] to-[rgba(107,0,182,0.1)] border-2 border-[rgba(194,0,111,0.5)]" data-id="element-98" data-mp="3b88wu1vmh3ea">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-99" data-mp="19g478x1lii6q">⚡</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-magenta-bright" data-id="element-100" data-mp="1eenud0rxe00o">
              GUILT
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-101" data-mp="1cytjhmpj3d9n">
              Shame does not heal — it empties you further. And a deeper
              emptiness demands more pleasure
            </div>
          </div>
          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-102" data-mp="130vxz6z1zukq">
            →
          </div>
          {/* Node 3: Emptiness */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(0,102,255,0.2)] to-[rgba(0,207,255,0.1)] border-2 border-[rgba(0,102,255,0.5)]" data-id="element-103" data-mp="1vn8cgfjep1d3">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-104" data-mp="1lw3wpdlwpch7">🌀</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-blue-light" data-id="element-105" data-mp="1hx4va2zdvxui">
              EMPTINESS
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-106" data-mp="2efsmmfrbshrk">
              Unresolved inner tension feeds the next urge
            </div>
          </div>
          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-107" data-mp="3sb11wet1ew60">
            ↩
          </div>
        </div>
        <div className="bg-gradient-to-br from-[rgba(107,0,182,0.25)] to-[rgba(194,0,111,0.15)] border border-[rgba(107,0,182,0.5)] rounded-2xl p-5 mt-3" data-id="element-108" data-mp="162dg1zd3iuh">
          <h3 className="text-[1.25rem] font-heading font-bold text-gold mb-2" data-id="element-109" data-mp="a4weq5nn0xed">
            🔑 The real reason you cannot stop
          </h3>
          <div className="text-[1rem] leading-[1.6] text-white/85 space-y-2" data-id="element-110" data-mp="f1mx4zmx052y">
            <p data-id="element-111" data-mp="k198t4n3hd9n">
              Your brain does not chase pleasure because you are weak. It chases
              it because at some point it learned that pleasure{' '}
              <strong data-id="element-112" data-mp="svduzaraa0iu">covers the emptiness.</strong> An inner tension with no
              name, which the behavior interrupts temporarily.
            </p>
            <p data-id="element-113" data-mp="xs4c81etr25u">
              The problem is what comes next: guilt. Guilt does not heal you —{' '}
              <strong data-id="element-114" data-mp="12r7ddarooo8j">it empties you further.</strong> It creates a deeper
              version of the original emptiness. And a deeper emptiness needs
              more pleasure to cover it.
            </p>
            <p className="text-gold font-bold" data-id="element-115" data-mp="k5nn8u27p61k">
              PLEASURE, GUILT AND EMPTINESS breaks that loop from the inside —
              with specific daily practices for each point of the cycle.
            </p>
          </div>
        </div>
      </div>
    </section>;
}